import React from 'react';
import history from "../../history";
import {Container, Row, Col} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

// Icons
import backButtonImage from "../../assets/images/back_icon.svg";
import backButtonImageLight from "../../assets/images/back_icon_light.svg";
import menuBurgerImage from "../../assets/images/menu_burger.svg";
import menuBurgerImageLight from "../../assets/images/menu_burger_light.svg";

// CSS Files
import "./Header.css";

const Header = (props) => {
   const { t } = useTranslation();

   function goBack() {
      history.goBack();
   }

   return (
      <>
         <div className={"Header" + (props.headerLight ? " light" : "") + (props.class ? ` ${props.class}` : "")}>
            <Container>
               <Row>
                  <Col xs={2} sm={2}>
                     {!props.showBackButton &&
                        <button className={"menu-burger-button" + (props.headerLight ? " dark" : "")} onClick={() => window.setShowMenu(true)}>
                           <img src={props.headerLight ? menuBurgerImageLight : menuBurgerImage} alt="menu burger button"/>
                        </button>
                     }
                     {props.showBackButton &&
                        <div className={"d-flex align-items-center cursor-pointer back-btn-container header-back-button" + (props.headerLight ? " dark" : "")} onClick={() => goBack()}>
                           <img src={props.headerLight ? backButtonImageLight : backButtonImage} alt="header-back-button"/>
                           <p className={"back-btn-text ml-3" + (props.headerLight ? " dark-text" : "")}>{t("common.back")}</p>
                        </div>
                     }
                  </Col>
                  <Col xs={8} sm={8} className={"pl-0"}>
                     {props.headerBarTitle &&
                        <h1 className={props.headerLight ? "dark" : ""}>{props.headerBarTitle}</h1>
                     }
                     {props.headerBarContent}
                  </Col>
                  <Col xs={2} sm={2}>{props.headerButtonRight}</Col>
               </Row>
               <Row>
                  {props.showHeaderExtras &&
                     <Col xs={12} className={"bigtitle"}>
                        {props.children}
                     </Col>}
               </Row>
            </Container>
         </div>
      </>
   )
}

export default Header
